import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LOGO = "https://customer-assets.emergentagent.com/job_dfd40c82-155c-446f-b6a2-3614c96b8638/artifacts/l43p30e7_Frame%20%283%29%20%282%29.png";

const links = [
  { to: "/", label: "Home" },
  { to: "/products", label: "Products" },
  { to: "/services", label: "Services" },
  { to: "/blog", label: "Blog" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header
      data-testid="site-header"
      className="backdrop-blur-xl bg-white/85 sticky top-0 z-50 border-b border-zinc-100"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-20">
        <Link to="/" className="flex items-center gap-3" data-testid="header-logo">
          <img src={LOGO} alt="Reptile Global" className="h-12 w-auto object-contain bg-white rounded" />
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `px-4 py-2 text-sm font-semibold rounded-full transition-colors ${
                  isActive ? "text-orange-600 bg-orange-50" : "text-zinc-700 hover:text-orange-600 hover:bg-zinc-50"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/contact"
            data-testid="header-cta-talk"
            className="bg-orange-500 text-white hover:bg-orange-600 px-5 py-2.5 rounded-full font-semibold text-sm transition-colors"
          >
            Talk to us
          </Link>
        </div>

        <button
          onClick={() => setOpen((v) => !v)}
          className="md:hidden p-2 rounded-lg text-zinc-700"
          data-testid="header-menu-toggle"
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-zinc-100 bg-white">
          <div className="px-4 py-3 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`mnav-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `px-3 py-2 text-sm font-semibold rounded-md ${
                    isActive ? "text-orange-600 bg-orange-50" : "text-zinc-700"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              onClick={() => setOpen(false)}
              className="mt-2 bg-orange-500 text-white hover:bg-orange-600 px-4 py-2.5 rounded-full font-semibold text-sm text-center"
              data-testid="mheader-cta-talk"
            >
              Talk to us
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
